import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { IconButton, Text } from '@chakra-ui/react';

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CutText from "shared/components/CutText";
import { PathsE } from "shared/routes";
import useGetColors from "shared/hooks/useGetColors";
import MuiIcon from "components/MuiIcon";
import { BlackListDTO } from "../../../api/types/blacklist";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
  ];
}

interface Params {
  handleDeleteRow: (telegramId: number) => Promise<void>,
}

export const useGetColumns = ({ handleDeleteRow }: Params) => {
  const { red500 } = useGetColors();
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<BlackListDTO>();

  return useMemo(
    () => [
      columnHelper.accessor('key', {
        header: t('services.table.key'),
        id: 'key',
        cell: ({ getValue }) => (
          <CutText fontWeight="700">
            {getValue()}
          </CutText>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '90px',
              maxW: '90px',
            }
          }
        }
      }),
      columnHelper.accessor('telegram_id', {
        header:'Telegram ID',
        id: 'telegram_id',
        cell: ({ getValue }) => (
          <Text fontWeight="700">
            {getValue()}
          </Text>
        ),
        meta: {
          isSorting: false,
        }
      }),
      
      columnHelper.accessor('id', {
        header: '',
        id: 'actions',
        cell: ({ row }) => (
            <IconButton
              aria-label="Delete"
              borderRadius="10px"
              backgroundColor="transparent"
              icon={<MuiIcon name="delete" color={red500} />}
              onClick={() => handleDeleteRow(row.original.telegram_id)}
            />
        ),
        meta: {
          styles: {
            sizes: {
              width: '44px'
            }
          }
        }
      }),
    ] as ColumnDef<BlackListDTO>[],
    [t]
  );
};
